import PropTypes from "prop-types";
import { AppBar, Toolbar } from "@mui/material";
import { styled } from "@mui/material/styles";

import CreateButton from "components/CreateButton";
import CastNumberSelect from "components/CastNumberSelect";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";

const ActionsContainer = styled("div")(() => ({
  width: "100%",
  padding: "10px 0",
  display: "flex",
  flex: 1,
  alignItems: "center",
  justifyContent: "space-around",
}));

const StickyActions = ({ loading, templateGroup }) => {
  return (
    <AppBar position="sticky" color="neutral" sx={{ top: "auto", bottom: 0 }}>
      <Toolbar disableGutters>
        <ActionsContainer>
          <CastNumberSelect templateGroup={templateGroup} size="small" />
          <CreateButton loading={loading} buttonText="Create Invite" size="small" />
        </ActionsContainer>
      </Toolbar>
    </AppBar>
  );
};

StickyActions.propTypes = {
  loading: PropTypes.bool,
  templateGroup: TemplateGroupPresenter.shape(),
};

export default StickyActions;
